// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Dashboard_wrapper__3GXKJ","sidebar":"Dashboard_sidebar__2QFbp","main":"Dashboard_main__Lfgfs","child__wrapper":"Dashboard_child__wrapper__ZY4Ie"};